// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"announcements_wrapper_3K8CkL_","button":"announcements_button_1hArSwD","counter":"announcements_counter_3TFCVId"};